import { defineStore } from "pinia";

import type { FiltersStoreType } from "@/types/filters/index.ts";

export const useFiltersStore = defineStore("filtersStore", {
  state: (): FiltersStoreType => ({
    isOpenSidebar: false,
    isOpenNavMenu: false,
    isShowMobileMenu: false,
  }),

  actions: {
    toggleFilterbar(value: boolean) {
      this.isOpenSidebar = value;
    },

    handleNavMenu(value: boolean) {
      this.isOpenNavMenu = !value;
    },

    handleMobileMenu(value: boolean) {
      this.isShowMobileMenu = value;
    },
  },
});
